import React, { useContext } from "react"
import { Helmet } from "react-helmet-async"
import { Container } from "reactstrap"
import { RecordPageView } from "App"
import DashboardComponent from "./dashboardComponent"
import AuthContext from "context/auth/authContext"

const NewDashboard = () => {
  RecordPageView()

  const { user } = useContext(AuthContext)

  return (
    <React.Fragment>
      <div className="page-content">
        <Helmet>
          <title>Planhopper | Proyectos</title>
        </Helmet>
        <Container fluid>{user && <DashboardComponent />}</Container>
      </div>
    </React.Fragment>
  )
}

export default NewDashboard
